import request from '@/router/axios';

export const getList = (current, size, params) => {
    return request({
        url: '/api/blade-dossier/dossierproblemdemand/page',
        method: 'get',
        params: {
            ...params,
            current,
            size,
        }
    })
}

export const getDetail = (id) => {
    return request({
        url: 'blade-dossier/dossierproblemdemand/detail/' + id,
        method: 'get'
    })
}

export const remove = (ids) => {
    return request({
        url: '/api/blade-dossier/dossierproblemdemand/remove',
        method: 'post',
        params: {
            ids,
        }
    })
}
export const update = (row) => {
    return request({
        url: '/api/blade-dossier/dossierproblemdemand/update',
        method: 'post',
        data: row
    })
}

export const add = (row) => {
    return request({
        url: '/api/blade-dossier/dossierproblemdemand/save',
        method: 'post',
        data: row
    })
}
